import React from 'react';
import { PropTypes } from 'prop-types';
import { Tooltip } from 'react-tooltip';
import Icon from '../Icons/Icon';
import 'react-tooltip/dist/react-tooltip.css';

const HeaderIconTooltip = ({
  heading = undefined,
  spanTextStart,
  linkUrl,
  linkText,
  spanTextEnd,
  place,
  iconName,
  icon,
  onClick = () => { },
  className = '',
  tooltipClassName = '',
  // helps to center the icon if it has tooltip inside (ex in SiteDetailPageTabs)
  paddingBottom = 3,
  divTextStart = '',
  divTextEnd = '',
  margins = 'mt-20 mb-6',
  // we need to pass border="" to remove the border
  border = 'border-b border-vamos-blue-gray',
  // If you need multiple tooltips on the same page, pass a unique tooltipId for each tooltip as a prop.
  // If you only need a single tooltip on the page, the default tooltipId ('info-tooltip') is already set for you.
  tooltipId = 'info-tooltip',
  iconSize = '',
  labelFontClassName = undefined,
  gap = undefined,
  iconPosition = 'items-center',
  dataTestId = undefined,
  classForWrappingIconDiv = '',
  iconClass = '',
}) => {
  return (
    <div className={`flex ${iconPosition} ${gap || 'gap-1'} ${border} ${margins} pb-${paddingBottom} ${className}`}>
      {heading && (
        <h2 className={`text-vamos-black ${labelFontClassName || 'font-sans text-xl font-bold'}`}>
          {heading}
        </h2>
      )}
      <div
        data-tooltip-id={tooltipId}
        role="button"
        className={`bg-transparent border-none p-0 cursor-pointer ${classForWrappingIconDiv}`}
        onClick={onClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick(e);
          }
        }}
        data-testid={dataTestId}
      >
        {iconName && <Icon name={iconName} className={`${iconSize} ${iconClass} text-vamos-black cursor-pointer`} />}
        {icon && icon}
      </div>
      <Tooltip
        id={tooltipId}
        clickable
        place={place}
        className={`${tooltipClassName} z-[9999]`}
      >
        {(divTextStart && divTextEnd)
          ? (
            <>
              <div>
                {divTextStart}
              </div>
              <div>
                {divTextEnd}{' '}
                {linkText && linkUrl && <a href={linkUrl}>{linkText}</a>}
              </div>
            </>
          )
          : (
            <span>
              {spanTextStart}{' '}
              <a href={linkUrl}>{linkText}</a>{spanTextEnd}
            </span>
          )}
      </Tooltip>
    </div>
  );
};

HeaderIconTooltip.propTypes = {
  heading: PropTypes.string,
  spanTextStart: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  spanTextEnd: PropTypes.string,
  place: PropTypes.oneOf(['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),
  iconName: PropTypes.string,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  divTextStart: PropTypes.string,
  divTextEnd: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  margins: PropTypes.string,
  border: PropTypes.string,
  tooltipId: PropTypes.string,
  iconSize: PropTypes.string,
  labelFontClassName: PropTypes.string,
  tooltipClassName: PropTypes.string,
  gap: PropTypes.string,
  iconPosition: PropTypes.string,
  dataTestId: PropTypes.string,
  classForWrappingIconDiv: PropTypes.string,
  iconClass: PropTypes.string,
};

export default HeaderIconTooltip;
